export default __webpack_public_path__ + "static/media/ch.6cc6aeb1.svg";